import React, { useState } from 'react'
import { Form, Typography, Card, Space } from 'antd'
import { useCompanyStore } from '../../store/company/companyStore'
import { useApi } from '../../services/ApiContext'
import { EditableTextArea } from '../../components/Common/EditableTextArea'

const { Title, Text } = Typography

export const ProjectSettings: React.FC = () => {
    const company = useCompanyStore((state) => state.company)
    const api = useApi()
    const [isEditingHeader, setIsEditingHeader] = useState(false)
    const [isEditingFooter, setIsEditingFooter] = useState(false)
    const [tempHeaderValue, setTempHeaderValue] = useState(company?.projectSettings?.defaultHeader || '')
    const [tempFooterValue, setTempFooterValue] = useState(company?.projectSettings?.defaultFooter || '')

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const updateSettings = (values: any) => {
        api.syncCompany({
            projectSettings: values,
        })
    }

    const handleHeaderChange = (value: string) => {
        setTempHeaderValue(value)
    }

    const handleFooterChange = (value: string) => {
        setTempFooterValue(value)
    }

    const handleHeaderSave = () => {
        updateSettings({
            ...company?.projectSettings,
            defaultHeader: tempHeaderValue
        })
    }

    const handleFooterSave = () => {
        updateSettings({
            ...company?.projectSettings,
            defaultFooter: tempFooterValue
        })
    }

    const handleHeaderCancel = () => {
        setTempHeaderValue(company?.projectSettings?.defaultHeader || '')
        setIsEditingHeader(false)
    }

    const handleFooterCancel = () => {
        setTempFooterValue(company?.projectSettings?.defaultFooter || '')
        setIsEditingFooter(false)
    }

    return (
        <div className="space-y-6">
            <Card>
                <Title level={5}>Project Settings</Title>
                <Text type="secondary" className="block mb-6">
                    Configure default settings for new projects and documents
                </Text>

                <Space direction="vertical" className="w-full">
                    <div>
                        <Text strong className="block mb-2">Default Header</Text>
                        <Text type="secondary" className="block mb-2">
                            This header content will be automatically added to new FF&E documents
                        </Text>
                        <div className='border border-gray-200 rounded-md p-2'>
                            <EditableTextArea
                                isEditing={isEditingHeader}
                                setIsEditing={setIsEditingHeader}
                                value={tempHeaderValue}
                                onChange={handleHeaderChange}
                                placeholder="Click to add default header content for new documents..."
                                showSaveButton={true}
                                onSave={handleHeaderSave}
                                onCancel={handleHeaderCancel}
                            />
                        </div>
                    </div>

                    <div>
                        <Text strong className="block mb-2">Default Footer</Text>
                        <Text type="secondary" className="block mb-2">
                            This footer content will be automatically added to new FF&E documents
                        </Text>
                        <div className='border border-gray-200 rounded-md p-2'>
                            <EditableTextArea
                                isEditing={isEditingFooter}
                                setIsEditing={setIsEditingFooter}
                                value={tempFooterValue}
                                onChange={handleFooterChange}
                                placeholder="Click to add default footer content for new documents..."
                                showSaveButton={true}
                                onSave={handleFooterSave}
                                onCancel={handleFooterCancel}
                            />
                        </div>
                    </div>
                </Space>
            </Card>
        </div>
    )
} 